
$controllers.main = {
	
	onLoad : function() {
		$models.main.currentEmailsListOffset = 0;
		$models.main.currentEmailsTotalCount = 0;
		$models.main.currentParams = {};
		$controllers.main.currentlyRequestingMoreEmails = false;
		jQuery('html, body').addClass('overflowHidden');
	},
	
	onUnload : function() {
		jQuery('.email-list').unbind('scroll');
		jQuery('html, body').removeClass('overflowHidden');
	},
	
	display : function($params) {
		
		// load all folders and tags, if they aren't already loaded
		if (!$controllers.all.enforcePagePermissions('main')) { return false; }
		if ($params && $params.folder_ids) {
			$cached.folders.loadSpecificItem(parseInt($params.folder_ids));
		}
		$cached.folders.load();
		$cached.tags.load();
		$cached.searchdata.load();
		
		// ensure the folders and tags have finished loading before proceeding  /* THIS IS IMPORTANT: REFER #1085 */
		if ($cached.folders.dataHasLoaded() && $cached.tags.dataHasLoaded() && $cached.searchdata.dataHasLoaded()) {
			$controllers.main.displayMainScreen($params);
		} else {
			// folders and/or tags are still loading, lets wait 50 msec and then try again!
			setTimeout(function() {
				$controllers.main.display($params);
			}, 50);
		}
		
	},
	
	displayMainScreen : function($params) {
		
		// handle edge cases where $params is not supplied
		$params = $params || {};
		
		// unless Specific Email is in the params, remove any Specific Email filter
		if (!$params.ids) {
			$soupmail.helpers.filter.$filters.specificEmailFilter = '';
		}
		
		// reset stuff if we've come to this page directly from another page
		if ($views.all.getCurrentScreen() != 'main') {
			jQuery($ultrasearch.obj).val('');
		}
		
		// display the main view
		$controllers.all.showPage('main', 'contentpage', $params);
		console.log('-----------------------------------------------------'); console.log(' ');
		
		// prevent clicking on any <a href>'s in the filter dropdown
		jQuery('#search-options li a').click(function(e) {
			e.preventDefault();
		});
		
		// startup / reset the filters
		$soupmail.helpers.filter.$filters.init();
		
// populateFilterItemsFromParams could do with some refactoring....
		$controllers.main.populateFilterItemsFromParams($params);
		
		// main page JS that detects scrolling to the bottom of the LHS list, and shows more emails when it needs to
		jQuery('.email-list').scroll(function(){
			//console.log('current: '+jQuery('.soupmail-main-list').scrollTop() + ' / '+(jQuery('.soupmail-main-list .widebox').height() - 800)+ ' / '+($controllers.main.currentlyRequestingMoreEmails ? 'yes' : 'no'));
			if (!$controllers.main.currentlyRequestingMoreEmails && ((jQuery('.email-list').scrollTop()+jQuery(window).height()) > (jQuery('.email-list .widebox').height() - 200))){
				if (($models.main.currentEmailsListOffset + 100) <= $models.main.currentEmailsTotalCount) {
					console.log('SCROLLED TO BOTTOM OF LHS LIST - LOAD MORE EMAILS IN LHS LIST!!');
					$controllers.main.currentlyRequestingMoreEmails = true;
					$models.main.currentEmailsListOffset += 100;
					$models.main.getEmailsList();
				} else {
					console.log('HIT THE ABSOLUTE BOTTOM OF LHS LIST - NO MORE EMAILS IN LHS LIST!!');
				}
			}
		});
		
		// if we've come here via a search box, add that search text into our main screen search box
		var $fk = 'filters[keywords]';
		if (($params != undefined) && $params[$fk] && ($params[$fk] != '')) {
			console.log('update search');
			jQuery('#mod-search-searchword').val($params[$fk]);
		}
		
		// show all LHS emails in list
		console.log('Get emails list from main display');
		$models.main.currentEmailsListOffset = 0;
		$models.main.getEmailsList($params);
		
		$views.main.resizeLHScolumn();
		$soupmail.helpers.filter.$filters.renderMenu($params);
		$soupmail.helpers.filter.rebuildFilterByBar();
		$soupmail.helpers.filter.toggleClearFilterButton();
		
		if (!$cached.folders.isEmpty() && ($params.folder_ids > 0)) {
			$views.main.renderCachedFoldersToFilterMenu($params, true);
			$soupmail.helpers.filter.$filters._items['search_folders_folder'+$params.folder_ids].selected = true;
			$soupmail.helpers.filter.rebuildFilterByBar();
			$soupmail.helpers.filter.toggleClearFilterButton();
		}
		
		jQuery(window).resize(function() {
			$views.main.resizeLHScolumn();
            $soupmail.helpers.filter.toggleOtherFiltersIndicator();
		});
		
		$controllers.all.setNavigation($params);
		
	},
	
	setupEventHandlers : function() {
		
		jQuery('#header').click(function() {
			if ($controllers.all.preventHeaderClickHandler == false) {
				jQuery('#search-options, #soupmail-searchfilter-closearea').hide();
				$views.main.resizeLHScolumn();
			}
		});
		
		jQuery('.search .filterbutton').click(function(event) {
			event.stopPropagation();
			$soupmail.helpers.filter.$filters.renderMenu();
			jQuery('#search-filter-list-indicator').removeClass('expanded');
			jQuery('#search-options').slideToggle(function() {
				$views.main.resizeLHScolumn();
			});
		});
		
		jQuery('#search-filter-list-indicator').click(function(event) {
			if (jQuery(this).hasClass('expanded')) {
				event.stopPropagation();
				jQuery('#soupmail-searchfilter-closearea').show();
			}
		});
		
// TODO :: can   #soupmail-searchfilter-closearea   be removed, everywhere??
		jQuery('#soupmail-searchfilter-closearea').click(function() {
			jQuery('#search-options, #soupmail-searchfilter-closearea').hide();
			jQuery('.dashboard-ultrasearch-results').hide();
			jQuery('#search-filter-list-indicator').removeClass('expanded');
		});
		
	},
	
// populateFilterItemsFromParams could do with some refactoring....
	populateFilterItemsFromParams : function($params) {
		
		jQuery.each($soupmail.helpers.filter.$filters._items, function() {
			
			// reverse filter My Emails
			if ((this.id == 'search_emails_mine') && ($params['filters[involving]'] == $models.login.getUsername())) {
				this.selected = true;
			}
			
			// filter Others Emails
			if ((this.id == 'search_emails_other') && ($params['filters[not_involving]'] == $models.login.getUsername())) {
				this.selected = true;
			}
			
			// filter any FROM checkboxes
			if ((this.val == $params['filters[from]']) && (this.parent == 'search_emails_sender')) {
				this.selected = true;
			}
			
			// filter any TO checkboxes
			if ((this.val == $params['filters[received_by]']) && (this.parent == 'search_emails_recepient')) {
				this.selected = true;
			}
			
			// filter any INVOLVING checkboxes
			if ((this.val == $params['filters[involving]']) && (this.parent == 'search_emails_involving')) {
				this.selected = true;
			}
			
			// filter WITH ATTACHMENTS checkbox
			if ((this.id == 'search_emails_attachments') && ($params['filters[attachments]'] == 'true')) {
				this.selected = true;
			}
			
			// filter any folder checkboxes
			if ((this.id.replace('search_folders_folder', '') == $params['folder_ids']) && (this.parent == 'search_emails_folder')) {
				this.selected = true;
			}
			
			// filter any Date Range
			var $dateFrom = new $soupmail.helpers.SoupMailDate();
			var $dateTo = new $soupmail.helpers.SoupMailDate();
			if (this.parent == 'search_emails_daterange') {
				switch (this.val) {
					case 'today':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case 'week':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusDays(7).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case 'month':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusMonths(1).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case '3month':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusMonths(3).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case '6month':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusMonths(6).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case '12month':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusMonths(12).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().toUTCString()) ) {
							this.selected = true;
						}
					break;
					case 'veryold':
						if ( ($params['filters[date_from]'] == $dateFrom.morning().minusMonths(40).toUTCString()) && ($params['filters[date_to]'] == $dateTo.night().minusMonths(12).toUTCString()) ) {
							this.selected = true;
						}
					break;
				}
			}
			/*
			// filter any Date From
			if (this.id == 'search_emails_datefrom') {
				var $dateFrom = new $soupmail.helpers.SoupMailDate(this.valAlternate + ' 00:00:00 ' + $dateFrom.toTimezoneOffset());
				if ($params['filters[date_from]'] == $dateFrom.morning().toUTCString()) {
					this.selected = true;
				}
			}
			
			// filter any Date To
			if (this.id == 'search_emails_dateto') {
				var $dateTo = new $soupmail.helpers.SoupMailDate(this.valAlternate + ' 23:59:59 ' + $dateFrom.toTimezoneOffset());
				console.log('COMPARE');
				console.log($params['filters[date_to]']);
				console.log($dateTo.night().toUTCString());
				if ($params['filters[date_to]'] == $dateTo.night().toUTCString()) {
					this.selected = true;
				}
			}
			*/
		});
		
	},
	/*
	addFilter : function() {
		
	},
	*/
	/*
	removeFilter : function() {
		
	},
	*/
	// call this function to remove all filters
	removeAllFilters : function($skipRebuildAll) {
		
		// first remove any "Specific Email" filter
		$soupmail.helpers.filter.$filters.specificEmailFilter = '';
		
		// WEIRD BUGFIX: for some reason the scroll handler fires when certain html changes occur, which causes problems.  For some reason we can't prevent the scroll handler from firing.  However, by setting this variable to true, when the scroll handler does fire, it will do nothing.
		$controllers.main.currentlyRequestingMoreEmails = true;
		
		console.log('removeAllFilters()');
		jQuery.each($soupmail.helpers.filter.$filters._items, function() {
			this.selected = false;
		});
		$soupmail.helpers.filter.$filters._items['search_emails_all'].selected = true;
		jQuery('.search .filterbutton').removeClass('active').removeClass('phone-active');
		jQuery('#search-filter-list-items').html('');
		jQuery('.email-list .email-list-item').remove();
		jQuery('#soupmail-email-preview').html('');
		if ($skipRebuildAll == true) {
			jQuery('.soupmail-filter-bar').slideUp(1, function() {
				$views.main.resizeLHScolumn();
			});
			console.log('removeAllFilters()... skipped doing a rebuild-all');
		} else {
			jQuery('.soupmail-filter-bar').slideUp(400, function() {
				$views.main.resizeLHScolumn();
			});
			$soupmail.helpers.filter.rebuildFilterByBar();
			$soupmail.helpers.filter.$filters.renderMenu();
            $soupmail.helpers.filter.toggleOtherFiltersIndicator();
			console.log('removeAllFilters()... Get emails list');
			$models.main.currentEmailsListOffset = 0;
			$models.main.getEmailsList({});
		}
		
	},
	/*
	search : function() {
		
	},
	*/
	viewEmail : function($emailid, $emailTitle, $folderId) {
		
		var $toLoad_params = {};
		if ($emailid) {
			$soupmail.helpers.filter.$filters.specificEmailFilter = {id: $emailid, subject: 'Specific email'};
			$toLoad_params['ids'] = $emailid;
		}
		if ($folderId) {
			//$soupmail.helpers.filter.$filters._items['search_folders_folder'+$folderId].selected = true;
			$toLoad_params['folder_ids'] = $folderId;
		}
		$controllers.main.display($toLoad_params);
		
	},
	
	deleteEmail : function($emailid) {
		$soupmail.modal.deletion('Are you sure you wish to remove this email from Soup Mail?<br/><br/>This will permanently remove the email and all associated files from the Soup Mail server.<br/><br/>This action is not reversible.', function() {
			jQuery('#soupmail-email-preview .headers').fadeTo(1, 0.2);
			jQuery('#soupmail-email-preview .body').fadeTo(1, 0.2);
			jQuery('.email-list-item-'+$emailid).addClass('email-list-item-deletion-in-progress');
			jQuery('.email-list-item-'+$emailid+' *').fadeTo(1, 0.2);
			$models.emails.deleteItem($emailid, function() {
				if (jQuery('.email-list-item-'+$emailid).next().size() > 0) {
					// we have more items below, so go to the NEXT one
					jQuery('.email-list-item-'+$emailid).next().click();
				} else if (jQuery('.email-list-item-'+$emailid).prev().size() > 0) {
					// we are at the bottom but we have emails above, so go to the PREV one
					jQuery('.email-list-item-'+$emailid).prev().click();
				} else {
					// we just deleted the last email from the list!
					jQuery('#soupmail-email-preview .headers').remove();
					jQuery('#soupmail-email-preview .body').remove();
					jQuery('.warning-http-resources').remove();
				}
				jQuery('.email-list-item-'+$emailid).slideUp(function() {
					jQuery('.email-list-item-'+$emailid).remove();
				});
				var $currentEmailCount = jQuery('.soupmail-main-left .count span').text();
				$currentEmailCount--;
				jQuery('.soupmail-main-left .count span').text($currentEmailCount);
			});
		});
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.mainpage.js